export default __webpack_public_path__ + "static/media/US_CITY.f480960f.png";